
import { calculateTextColor } from "@/helpers/suggestedColors";
import { defineComponent, PropType } from "vue";

interface PropLink {
  name: string;
  link?: string;
  backgroundColor: string;
}

export default defineComponent({
  name: "LUserLink",
  data() {
    return {
      colorText: "",
    };
  },
  mounted() {
    this.colorText = calculateTextColor(this.link.backgroundColor);
  },
  watch: {
    "link.backgroundColor"() {
      this.colorText = calculateTextColor(this.link.backgroundColor);
    },
  },

  props: {
    link: {
      type: Object as PropType<PropLink>,
      required: true,
    },
  },
});
